import {merge} from 'rxjs';
import {filter, map, scan} from 'rxjs/operators';
import {uiMsg$} from '@/ui';
import {wsLogout$} from '@/user/auth-ws';
import {contractSnapshotOrders$, contractIncrementalOrders$} from '@/orders-contract/orders-contract-all';
import {wsOpened$} from '@/ws';
import {createRemoveAction$, createSnapshotAction$, createUpdateAction$} from './order-conditional-contract-cache';
import type {FUOrderConditionRemove, ws} from '@/types';
type ContractOrderRaw = ws.ContractOrderRaw;

export type Cache = Map<string, ContractOrderRaw>;
type Action = (map: Cache) => Cache;

const resetAction$ = merge(wsLogout$, wsOpened$).pipe(
  map(
    (): Action => (cache: Cache) => {
      cache.clear();
      return cache;
    }
  )
);

const removeByUserAction$ = uiMsg$.pipe(
  filter((o) => o.type === 'order-condition-remove'),
  map<FUOrderConditionRemove, Action>((data) => (cache: Cache) => {
    cache.delete(data.orderID);
    return cache;
  })
);

const snapshotOrders$ = contractSnapshotOrders$.pipe(map(({orders: {open}}) => open));
const snapshotAction$ = createSnapshotAction$(snapshotOrders$);

const incrementalActiveOrders$ = contractIncrementalOrders$.pipe(
  map(({orders: {open, closed}}) => [...closed, ...open])
);
const updateAction$ = createUpdateAction$(incrementalActiveOrders$);

const incrementalClosedOrders$ = contractIncrementalOrders$.pipe(map(({orders: {closed}}) => closed));
const removeAction$ = createRemoveAction$(incrementalClosedOrders$);

export const contractConditionalOrdersAllCache$ = merge<[Action, Action, Action, Action, Action]>(
  snapshotAction$,
  updateAction$,
  removeAction$,
  resetAction$,
  removeByUserAction$
).pipe(scan((p, c) => c(p), new Map<string, ContractOrderRaw>()));
